$(function() {

	var filters = {

		el: {
			main: $('.filters')
		},

		init: function() {
			filters.el.main.on('click', '.filters__toggle', function() {
				filters.el.main.find('.filters__form').addClass('filters__form--open');
			}).on('click', '.filters__close', function() {
				filters.el.main.find('.filters__form').removeClass('filters__form--open');
			});
		}

	}

	filters.init();

});